export default __webpack_public_path__ + "static/media/fbx.3877de16.png";